// extracted by mini-css-extract-plugin
export default {"wrapper":"CertificationsBanner_wrapper__zpQ2a","eyebrow":"CertificationsBanner_eyebrow__cwP6c","title":"CertificationsBanner_title__o0+vX","icon":"CertificationsBanner_icon__AOaWR"};